import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgFacebookWhite = () => {
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.477 2 2 6.504 2 12.059c0 5.02 3.657 9.182 8.438 9.937v-7.03h-2.54V12.06h2.54V9.843c0-2.521 1.492-3.914 3.777-3.914 1.094 0 2.238.197 2.238.197V8.6h-1.26c-1.243 0-1.63.776-1.63 1.571v1.887h2.773l-.443 2.908h-2.33v7.029C18.343 21.24 22 17.08 22 12.059 22 6.504 17.523 2 12 2Z", fill: "#fff" }));
};
export default factorySvgIcon(SvgFacebookWhite);
//# sourceMappingURL=SvgFacebookWhite.js.map